import { getDecodedConsulData } from '@shared/lib/consul'
import { ServiceMetaType } from '../model/tsp.types'

export const fetchTspMetaDataById = async (id: string) => {
  const metaDataAll = await getDecodedConsulData<Record<string, ServiceMetaType>>('/meta/value')
  const metaData = metaDataAll[id]

  return metaData
}
